import { createBrowserHistory } from 'history';
import React from 'react';
import { Router } from 'react-router-dom';
if (!global.REACT_HISTORY) {
    global.REACT_HISTORY = createBrowserHistory();
}
/**
 * BrowserRouter
 * same as BrowserRouter from react-router-dom, but sharing the history globally
 */
var BrowserRouter = function (_a) {
    var children = _a.children;
    return (React.createElement(Router, { history: global.REACT_HISTORY }, children));
};
export default BrowserRouter;
//# sourceMappingURL=index.js.map